module.exports = __webpack_public_path__ + "img/product.f50ce9b0.svg";